let PackagesItem = [
    {
        id: 1,
        trackTitle: "Pro Track 🔥",
        trackSubtitle: "for experienced Android Developers",
        trackPrice: "$49",
        trackDesc: "1",
        trackButton: "Register",
        trackFull: 'Full Access to Q&A sessions',
        trackLink: 'https://geekle.us/ticket/1620464923433x986615051167465500',
    },
    {
        id: 2,
        trackTitle: "Career Track",
        trackSubtitle: "for Android Developers",
        trackPrice: "FREE",
        trackButton: "Register",
        trackQA: 'Live Q&A panels from a Career Track',
        trackLink: 'https://geekle.us/ticketfree/1620464573167x345258231749148700',
    },
  ];
  
  export default PackagesItem;
  